module.exports = __webpack_public_path__ + "static/edge-of-the-universe-48552043433a3242f4f48265d89c4e03.jpg";